module.exports = __webpack_public_path__ + "assets/img/t3.bf014a54.png";